import { render } from "./App.vue?vue&type=template&id=23ed1c78"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=23ed1c78&lang=scss"

import exportComponent from "C:\\development\\Pirca\\PircaSolutions.Forge\\PircaSolutions.Forge.AdminUI\\admin-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__